import type { GlobePointKind } from "#shared/schemas/globe.ts";

/** Per-kind pin styling — add an entry when city/studio points ship. */
export interface PointKindStyle {
  /** Base fill when idle / focused. */
  color: string;
  /** Dimmed fill when another focus is active (~25% language). */
  dimColor: string;
  minRadius: number;
  maxRadius: number;
  altitude: number;
}

export const POINT_KIND_STYLES: Record<GlobePointKind, PointKindStyle> = {
  country: {
    color: "#1ed760",
    dimColor: "rgba(30, 215, 96, 0.25)",
    minRadius: 0.35,
    maxRadius: 1.35,
    altitude: 0.01,
  },
  city: {
    color: "#4ea1ff",
    dimColor: "rgba(78, 161, 255, 0.25)",
    minRadius: 0.25,
    maxRadius: 0.9,
    altitude: 0.008,
  },
  studio: {
    color: "#e6b84d",
    dimColor: "rgba(230, 184, 77, 0.25)",
    minRadius: 0.2,
    maxRadius: 0.7,
    altitude: 0.006,
  },
};

/** Muted-neon playlist hues (accent-family, not carnival). Cycled by selection order. */
export const PLAYLIST_HUES = [
  "#5ce1a8",
  "#6ec8ff",
  "#c9a0ff",
  "#ffb86b",
  "#ff7aad",
] as const;

export const PLAYLIST_OBJECT_ALTITUDE = 0.35;
export const MAX_SELECTED_PLAYLISTS = 5;
export const MAX_ARCS_PER_PLAYLIST = 40;

/** Clamp artistCount into a pin radius for the given kind. */
export function pointRadiusForCount(
  kind: GlobePointKind,
  count: number,
  maxCount: number,
): number {
  const style = POINT_KIND_STYLES[kind];
  if (maxCount <= 1) return (style.minRadius + style.maxRadius) / 2;
  const t = Math.sqrt(Math.min(1, Math.max(0, count / maxCount)));
  return style.minRadius + t * (style.maxRadius - style.minRadius);
}
